import React, { useContext, useState, useEffect } from 'react';
import { FormContext } from './FormEngine';
import FormRow from './FormRow';
import colorWheel from '../Theme/ColorWheel';

// Function to get header style with current theme colors
const getHeaderStyle = () => ({
    position: 'relative',
    minHeight: '1em',
    margin: '1em 0 1em 0',
    background: colorWheel.messageBackground,
    padding: '.8em 1em',
    lineHeight: '1.4285em',
    fontSize: '1.07142857rem',
    fontWeight: 600,
    color: colorWheel.textGrey,
    borderRadius: '0.28571429rem',
    boxShadow: `0 0 0 1px ${colorWheel.neutral3} inset, 0 0 0 0 transparent`,
});


const FormSection = props => {
    const { name, fields, onChange } = props;
    const ctx = useContext(FormContext);
    const allFieldsHidden = fields.every(field => ctx.fieldState[field]?.hidden === true);
    const [headerStyle, setHeaderStyle] = useState(getHeaderStyle());

    return <>
        {!allFieldsHidden &&
            <>
                <div style={headerStyle} data-section={`section_de_${name}`}>{name}</div>

                {fields.map(field => {
                    const myDef = ctx.getFieldDef(field);
                    const myState = ctx.fieldState[field];
                    const myData = ctx.formData[field];
                    const myWarning = ctx.getWarning(myDef);

                    //TODO: there is an issue where I will get a field name in Layout that does not
                    //appear in the questions. I don't know if this is expected, or whether I have
                    //an issue in my SQL.
                    if (!myDef) return null;

                    return <FormRow
                        key={field}
                        def={myDef}
                        dataKey={field}
                        state={myState}
                        data={myData}
                        warning={myWarning}
                        onChange={onChange}
                    />
                })}
            </>
        }
    </>
}

export default FormSection;
